import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { FileText, CheckCircle, Clock, Shield } from 'lucide-react';

const RequestQuoteCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-gradient-to-br from-orange-600 to-orange-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Need a Professional? Get Free Quotes!
          </h2>
          <p className="text-xl text-orange-100 max-w-2xl mx-auto">
            Tell us about your project and receive quotes from multiple qualified professionals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <FileText className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Describe Your Project</h3>
            <p className="text-orange-100 text-sm">Fill out a simple form with your project details</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Get Multiple Quotes</h3>
            <p className="text-orange-100 text-sm">Receive quotes from verified professionals</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Choose the Best</h3>
            <p className="text-orange-100 text-sm">Compare and select the perfect pro for your job</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={() => navigate('/request-quote')}
            size="lg"
            className="bg-white text-orange-600 hover:bg-gray-100 font-bold px-8 py-6 text-lg shadow-xl"
          >
            <FileText className="mr-2 h-5 w-5" />
            Request Free Quotes
          </Button>
          <div className="flex items-center text-white text-sm">
            <Clock className="h-4 w-4 mr-2" />
            <span>Get responses within 24 hours</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequestQuoteCTA;
